import React from "react";
import { Snackbar, Alert as MuiAlert } from "@mui/material";

const Alert = ({
  open,
  message,
  severity,
  onClose,
  anchorOrigin = { vertical: "top", horizontal: "right" },
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <MuiAlert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default Alert;
